import { SharedChartWidget } from '../shared/chart/SharedChartWidget';
import { usePipelineHealthAdapter } from './hooks/useAdminCharts';
import { WidgetConfig } from '../../infrastructure/contracts/widget.contract';

export const adminPipelineHealthConfig: WidgetConfig = {
  id: 'admin-pipeline-health',
  title: 'Pipeline Health',
  icon: 'stacked_bar_chart',
  category: 'statistics',
  description: 'Status Breakdown',
  refreshStrategy: 'interval',
  defaultSize: { w: 3, h: 4 },
  priority: 3,
  supportedRoles: ['admin', 'superadmin']
};

export function AdminPipelineHealthWidget() {
  const dataQuery = usePipelineHealthAdapter();

  return (
    <SharedChartWidget
      config={adminPipelineHealthConfig}
      chartType="progress"
      dataQuery={dataQuery}
      emptyMessage="No pipeline data available."
    />
  );
}
